export default [
  {
    frontView: '#DAECBE',
    backgroundColor: '#82BF24'
  },
  {
    frontView: '#FEF7CC',
    backgroundColor: '#FBD601'
  },
  {
    frontView: '#FBE2CC',
    backgroundColor: '#EC6E00'
  },
  {
    frontView: '#CCEAF7',
    backgroundColor: '#0095D9'
  },
  {
    frontView: '#CCE4DF',
    backgroundColor: '#00785F'
  },
  {
    frontView: '#FAEBF2',
    backgroundColor: '#E799C0'
  },
  {
    frontView: '#EAF6F2',
    backgroundColor: '#98D1C0'
  },
  {
    frontView: '#DAE7DB',
    backgroundColor: '#48864D'
  }
]
